import styles from '../newCalculator.module.scss'
import { LoanTypeEnum } from '../newCalculator.models'
import { TranslatedStrings } from '../../../utils/translations/TranslatedStrings'
import Tab, { Tabs } from '../../../components/tabs'

interface MobileToggleProps {
	isPaymentReductionPlanActiveMobile: boolean
	setIsPaymentReductionPlanActiveMobile: (active: boolean) => void
	toggleExpandPaymentPlan: (type: LoanTypeEnum) => void
}

const MobileToggle = ({
	isPaymentReductionPlanActiveMobile,
	setIsPaymentReductionPlanActiveMobile,
	toggleExpandPaymentPlan,
}: MobileToggleProps) => {
	return (
		<div className={styles.bodyTopSwitch}>
			<Tabs>
				<Tab
					title={TranslatedStrings.is.newCalculator.equalization}
					value={1}
					onClick={() => {
						setIsPaymentReductionPlanActiveMobile(false)
						toggleExpandPaymentPlan(LoanTypeEnum.ASSET_FORMATION)
					}}
					selected={!isPaymentReductionPlanActiveMobile}
					variant='darkBackground'
				/>
				<Tab
					title={TranslatedStrings.is.newCalculator.reduction}
					value={2}
					onClick={() => {
						setIsPaymentReductionPlanActiveMobile(true)
						toggleExpandPaymentPlan(LoanTypeEnum.PAYMENT_REDUCTION)
					}}
					selected={isPaymentReductionPlanActiveMobile}
					variant='darkBackground'
				/>
			</Tabs>
		</div>
	)
}

export default MobileToggle
